export const GlobalSearchLocalStorageName = 'coveo_standalone_search_box_data';
export const GlobalSearchTypeLocalStorage = 'coveo_standalone_search_type';
export const CoveoElementAttributeName = 'coveoconfig';
export const StandaloneSiteLabel = 'Enter keywords for product info, help, etc';
export const StandaloneCustomerLabel = 'Enter customer, policy, email, claim or phone';
export const IADocsSourceName = 'IADocs';
export const UrlParamNameSearch = 'q';
export const UrlParamTypeSearch = 'qtype';
